/**
 * Scrolls the window to the top whenever the route pathname changes.
 * Prevents users from landing mid-page after navigating between routes.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
